import { RefreshCw } from 'lucide-react'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import { Button } from '@/components/ui/button'
import { useI18n } from '@/lib/i18n'
import { isStaleBuildError } from '@/lib/updates'

/** Shown instead of React Router's developer screen when a page fails to load. */
export function RouteError() {
  const { t } = useI18n()
  const error = useRouteError()
  const stale = isStaleBuildError(error)
  const detail = isRouteErrorResponse(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : null
  return (
    <div className="grid min-h-[60vh] place-items-center px-4 py-16 text-center">
      <div className="max-w-md">
        <p className="text-xl font-semibold">{stale ? t('A new version of the dashboard is ready') : t('Something went wrong')}</p>
        <p className="mt-2 text-sm text-text-2">{stale ? t('Reload to get it. Nothing you saved is lost.') : t('Reload the page. If it keeps happening, tell us what you were doing.')}</p>
        {!stale && detail && <p className="mt-3 break-words rounded-lg bg-surface-3 p-2 font-mono text-xs text-text-2">{detail}</p>}
        <div className="mt-5 flex justify-center gap-2">
          <Button onClick={() => window.location.reload()}>
            <RefreshCw /> {t('Reload')}
          </Button>
          <Button variant="outline" onClick={() => window.location.assign('/')}>
            {t('Go to the dashboard')}
          </Button>
        </div>
      </div>
    </div>
  )
}
